import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import VehicleSection from "./components/VehicleSection";
import SuitableForSection from "./components/SuitableForSection";
import RequirementsSection from "./components/RequirementsSection";
import InsuranceGuidanceSection from "./components/InsuranceGuidanceSection";
import EnquirySection from "./components/EnquirySection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import ContractPage from "./components/ContractPage";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <VehicleSection />
        <SuitableForSection />
        <RequirementsSection />
        <InsuranceGuidanceSection />
        <EnquirySection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contract" element={<ContractPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
